import React, { useEffect, useRef, useState } from "react";

const formatWalletAmount = (value, unit) => {
  const number = Number(value);
  const formatted = Number.isFinite(number)
    ? number.toLocaleString("ko-KR", { maximumFractionDigits: 0 })
    : "0";
  return `${formatted}${unit}`;
};

const TotalMoneyContainer = ({ money, walletItems = [] }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleOutsidePointerDown = (event) => {
      if (!containerRef.current?.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsidePointerDown);
    return () => {
      document.removeEventListener("mousedown", handleOutsidePointerDown);
    };
  }, []);

  return (
    <div className="total-money-container" ref={containerRef}>
      <button
        type="button"
        className="total-money-trigger"
        aria-label={`보유금 ${money}`}
        aria-expanded={isOpen}
        onClick={() => setIsOpen((current) => !current)}
      >
        <span className="total-money-amount">{money}</span>
        <span className="total-money-unit" aria-hidden="true">
          원
        </span>
        <span className="total-money-chevron" aria-hidden="true">
          <svg viewBox="0 0 12 8" focusable="false">
            <path d="M1.4 1.2 6 5.7l4.6-4.5" />
          </svg>
        </span>
      </button>

      {isOpen ? (
        <div className="wallet-balance-dropdown" role="menu">
          {walletItems.map((item) => (
            <div className="wallet-balance-row" role="menuitem" key={item.key}>
              <span className="wallet-balance-label">{item.label}</span>
              <span className="wallet-balance-value">
                {formatWalletAmount(item.value, item.unit)}
              </span>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default TotalMoneyContainer;
